import {ColumnType} from 'antd/es/table';

import {IFieldMeta, IValidationRules} from 'entities/metadata';
import {TEntity, TEntityValue} from 'modules/data';

interface IEditableColumEntity extends Omit<IFieldMeta, 'inputProps' | 'getFieldState' | 'label' | 'type' | 'align'> {
    editable?: boolean;
    alwaysEditable?: boolean;
    dataIndex: string;
    inputType?: EEditableInput;
    inputProps?: IEditableTableInputProps;
    /**
     * Метод для создания динамических пропсов, на тот случай если возможностей inputProps не хватает
     * @param fieldKey
     * @param record
     */
    generateInputProps?: (fieldKey: string, record?: TEntity) => IEditableTableInputProps;
    getFieldState?: (fieldKey: string, record: TEntity) => TFieldStateType;
    required?: boolean;
    defaultValue?: TEntityValue;
    validationRules?: IValidationRules[];
    width?: number | string;
}

export type TEditableColumn = ColumnType<any> & IEditableColumEntity;

export type TFieldStateType = {
    activated?: boolean;
    required?: boolean;
    dependencies?: string | string[];
    disabled?: boolean;
};

export enum EEditableInput {
    TEXT = 'TEXT',
    SELECT = 'SELECT',
    TEMPLATE_SELECT = 'TEMPLATE_SELECT',
    DATE = 'DATE',
    INPUT_NUMBER = 'INPUT_NUMBER',
    TEXT_MODAL = 'TEXT_MODAL',
    FILES_MODAL = 'FILES_MODAL'
}

export interface IEditableTableInputProps {
    options?: {
        label: string;
        value: string;
    }[];

    [key: string]: any;
}

export interface IValidationController {
    validateAllRows?: (data?: TEntity[]) => Promise<boolean>;
    getAllFieldErrors?: () => Record<string, string[]>[];
}
